import React, {FunctionComponent} from 'react';
import ShopContainer from "containers/ShopContainer";


type LayoutProps = {
    deviceType: {
        mobile: boolean;
        tablet: boolean;
        desktop: boolean;
    };
};

const Layout: FunctionComponent<LayoutProps> = ({
                                                    children,
                                                }) => {
    return (
        <ShopContainer>
            {children}
        </ShopContainer>
    );
};

export default Layout;
